import "core-js/modules/es.array.index-of.js";
import Cookies from 'js-cookie';
var TokenKey = 'PMS_Admin-Token';
var refleshToken = 'PMS_Admin-reflesh-Token';
var EntSernoKey = 'PMS_ent-serno';
var UserKey = 'PMS_userId';
var CurrentIp = 'PMS_currentIp';
var CurrentPort = 'PMS_currentPort';
var broUpdateTime = 'broUpdateTime';
var userPayInfoUrl = 'user_pay_info_url';
export function getCurrentIp() {
  return Cookies.get(CurrentIp);
}
export function setCurrentIp(ip) {
  return Cookies.set(CurrentIp, ip);
}
export function getCurrentPort() {
  return Cookies.get(CurrentPort);
}
export function setCurrentPort(port) {
  return Cookies.set(CurrentPort, port);
}
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function getRfleshToken() {
  return Cookies.get(refleshToken);
}
export function setRfleshToken(token) {
  return Cookies.set(refleshToken, token);
}
export function getUserId() {
  return Cookies.get(UserKey);
}
export function setUserId(userId) {
  return Cookies.set(UserKey, userId);
}
export function setEntSerno(entSerno) {
  return Cookies.set(EntSernoKey, entSerno);
}
export function getEntSerno() {
  return Cookies.get(EntSernoKey);
}
export function removeUserId() {
  return Cookies.remove(UserKey);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function removeEntSerno() {
  return Cookies.remove(EntSernoKey);
}
export function setBroUpdateTime(time) {
  return localStorage.setItem(broUpdateTime, time);
}
export function getBroUpdateTime(time) {
  return localStorage.getItem(broUpdateTime);
}
export function getPayUrl() {
  return Cookies.get(userPayInfoUrl);
}
export function setPayUrl(url) {
  return Cookies.set(userPayInfoUrl, url);
}
export function getApi(env) {
  if (getCurrentIp() === null || getCurrentIp() === '' || getCurrentIp() === undefined) {
    env.BASE_URL = 'http://' + env.DEFAULT_IP;
    return 'http://' + env.DEFAULT_IP + ':' + env.DEFAULT_API_PORT + env.BASE_API;
  } else {
    if (!(getCurrentIp().indexOf('localhost') > -1 || getCurrentIp().indexOf('127.0.0.1') > -1)) {
      env.DEFAULT_IP = getCurrentIp();
    }

    if (getCurrentPort() !== '') {
      if (!(getCurrentPort() === '80')) {
        env.DEFAULT_EXTRANET_API_PORT = getCurrentPort();
      }
    }

    return 'http://' + env.DEFAULT_IP + ':' + env.DEFAULT_EXTRANET_API_PORT + env.BASE_API;
  }
}